import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { usePriestAuth } from '../context/PriestAuthContext';

export default function PriestLogin() {
  const { login, loading, error, clearError, priest } = usePriestAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ identifier: '', password: '' });
  const [showPw, setShowPw] = useState(false);
  const [formError, setFormError] = useState('');

  useEffect(() => { if (priest) navigate('/priest/dashboard', { replace: true }); }, [priest, navigate]);
  useEffect(() => { clearError(); }, []); // eslint-disable-line

  const onChange = (e) => {
    setForm(p => ({ ...p, [e.target.name]: e.target.value }));
    setFormError('');
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.identifier || !form.password) { setFormError('Email or mobile number, and password are required'); return; }
    try {
      await login(form.identifier.trim(), form.password);
      navigate('/priest/dashboard', { replace: true });
    } catch { /* error from context */ }
  };

  return (
    <div className="auth-page">
      <div className="auth-card priest-auth-card">
        <div className="auth-header">
          <span className="auth-icon">🕉️</span>
          <h1>Purohit Login</h1>
          <p>Sign in to your priest dashboard</p>
        </div>

        <form onSubmit={onSubmit} noValidate>
          {(formError || error) && (
            <div className="auth-error"><span>⚠️</span> {formError || error}</div>
          )}

          <div className="form-group">
            <label htmlFor="identifier">Email or Mobile Number</label>
            <input id="identifier" name="identifier" type="text" autoComplete="username"
              placeholder="priest@example.com or 9876543210" value={form.identifier}
              onChange={onChange} disabled={loading} />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="auth-input-wrapper">
              <input id="password" name="password" type={showPw ? 'text' : 'password'}
                autoComplete="off" placeholder="Your password"
                value={form.password} onChange={onChange} disabled={loading} />
              <button type="button" className="auth-toggle-pw"
                onClick={() => setShowPw(v => !v)}>
                {showPw ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          <button type="submit" className="btn btn-primary auth-submit" disabled={loading}>
            {loading ? <span className="auth-spinner" /> : 'Enter Dashboard 🪔'}
          </button>
        </form>

        <div className="auth-footer">
          <p>New priest? <Link to="/priest/signup" className="auth-link">Register here</Link></p>
          <p style={{ marginTop: '0.5rem' }}>
            <Link to="/login" className="auth-link" style={{ fontSize: '0.8rem' }}>← User login instead</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
